import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RequiredPropertyIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "RequiredProperty",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m28.61 22.55-.54.89c-.55.94-1.78 1.24-2.7.64l-7.38-4.72.54 8.6c.08 1.1-.81 2.04-1.93 2.04h-1.09c-1.11 0-1.98-.94-1.93-2.04l.53-8.6-7.5 4.79c-.94.59-2.19.28-2.71-.69l-.53-.94c-.54-.97-.16-2.18.84-2.67l7.9-3.84-7.98-3.88c-1-.47-1.38-1.71-.82-2.68l.5-.86c.54-.96 1.78-1.25 2.7-.67l7.59 4.82-.51-8.71c-.08-1.1.81-2.04 1.93-2.04h1.11c1.11 0 1.98.94 1.93 2.04l-.51 8.68L25.45 8c.94-.59 2.19-.28 2.71.67l.5.88c.55.96.18 2.19-.82 2.67l-7.75 3.81 7.72 3.8c1.01.5 1.39 1.72.82 2.69h-.03Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.12 22.26 18.28 16l10.84-6.26c.55-.32.73-1.01.42-1.56-.32-.55-1.02-.73-1.56-.42l-10.84 6.26V1.14a1.14 1.14 0 1 0-2.28 0v12.88L4.02 7.76c-.55-.32-1.25-.13-1.56.42-.32.55-.13 1.25.42 1.56L13.72 16 2.88 22.26c-.55.32-.73 1.01-.42 1.56.21.37.6.57.99.57.19 0 .39-.05.57-.15l10.84-6.26v12.88a1.14 1.14 0 1 0 2.28 0V17.98l10.84 6.26c.18.1.38.15.57.15.39 0 .78-.21.99-.57.32-.55.13-1.25-.42-1.56"
      })
    })
  }));
};
RequiredPropertyIcon.displayName = 'RequiredPropertyIcon';